export default function Dialog() {
    return {
      MuiDialog: {
        styleOverrides: {
          root: {
            zIndex: 1000
          }
        }
      }
    };
  }